import { c as _c } from "react/compiler-runtime";
export const SolfiLogo = t0 => {
  const $ = _c(32);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M0,0h303v303H0V0z" fill="#151515" />;
    t3 = <path d={"M153,284.2c-1.2,0-2.3-0.1-3.5-0.1c-35.5-1.6-69-17.2-93.1-43.3c-24.7-27.1-37-61.7-34.9-98.4\n        C25.4,73.8,87.4,18.9,156,22.5l0,37.5c-4.2,0.2-8.5,0.3-12.6,0.7c-19.7,2.2-37.5,9.5-52.5,22.5C73,98.6,62,120.5,60.2,144\n        c-1.6,23.9,6.2,47.4,21.8,65.6c19.6,22.7,42,31.3,71.1,33.4C153.3,256.8,153.2,270.5,153,284.2z"} fill="#F5F5F4" />;
    t4 = <path d={"M156,22.5c3.6,0,7.3,0.4,10.9,0.8c56.9,6.3,104.7,51.5,113.4,108.1c0.4,2.8,0.9,6.3,1.1,9.2\n        c-11.7,1.2-27.2,4.3-38.5,4.7c-1.9-24.6-13.4-47.4-32.1-63.6c-11.9-10.4-26.5-17.5-42.1-20.3c-2.2-0.4-4.2-0.7-6.4-1\n        c-1.3-0.2-5.4-0.2-6.3-0.5L156,22.5z"} fill="#2C2C2C" />;
    t5 = <path d={"M123.7,136.9c5-0.4,11.2,0.2,15.5,3.2c5.6,3.9,6.5,12.6,2.5,17.9c-2.9,3.9-7.5,4.9-12.2,5.5\n        c-5.8,0.3-12.4,0.1-17.2-3.6c-5-4-5.6-13-1.5-17.8C114.1,138.1,118.9,137.3,123.7,136.9z"} fill="#F5F5F4" />;
    t6 = <path d={"M127.5,143.9c6.5,1.2,7.6,8.1,3.2,11.3c-1.2,0.9-2.6,1.3-4.1,1.3c-1.5,0.1-2.9,0-4.4-0.9\n        c-1.5-0.8-2.5-2.2-3-3.8c-0.8-3.1,0.5-5.6,2.9-7C123.7,143.9,125.7,143.6,127.5,143.9z"} fill="#151515" />;
    t7 = <path d={"M87.1,136.9c5.2-0.1,9,0.1,12.6,1.7c3.9,1.8,4.8,3.5,5.6,7c-2.9,0-10.8,0-10.8,0c-1.3-2.4-7.4-3.4-8.6-0.3\n        c-0.2,0.4,0.1,0.9,0.6,1c5.6,0.6,12.2,0.4,16.8,3.5c3.3,2.3,2.6,5.9,0.4,8.7c-2.2,2.7-5.1,3.8-8.3,4.5c-2,0.4-4.1,0.6-6.1,0.6\n        c-6.8,0.1-13.9-1.1-15-8.7l11.2,0c0,0,2,2.7,6.1,1.7c0.8-0.2,1.5-0.5,2.1-1.2c0.3-0.3,0.3-0.8,0-1c-1-0.8-3.3-0.8-4.4-0.8\n        c-7.6-0.3-18.9-2.8-13.1-11.7C78.2,138.8,82.2,137,87.1,136.9z"} fill="#F5F5F4" />;
    t8 = <path d={"M181.8,137.3c9.4-0.2,20.3-0.1,29.7,0c0,2.1,0,4.3,0,6.4l-18.8,0c0,1.3,0,2.7,0,4c2.3-0.3,10.1-0.2,12.9-0.2\n        c1,0,2,0,3,0l0,5.1l-15.8,0l0,10.3l-10.9,0L181.8,137.3z"} fill="#F5F5F4" />;
    t9 = <path d={"M148.3,137.3c3.6,0,7.3,0,10.9,0.1c0.1,6.4,0,12.9,0,19.2c6.2-0.1,12.9,0,19.2,0c-0.1,1.9,0,4.4,0,6.3\n        l-30.1,0.1L148.3,137.3z"} fill="#F5F5F4" />;
    t10 = <path d="M215.5,137.3l10.9,0l0,25.7l-11,0L215.5,137.3z" fill="#F5F5F4" />;
    t11 = <path d={"M231.3,196.1c1,0.6,2.1,1.5,3,2.1c10,7.3,20.6,14.5,30.2,22.3c-0.8,1.2-1.9,3.5-2.6,4.8\n        c-11.2-8.3-22.3-16.8-33.2-25.4C229.5,198.9,230.5,197.3,231.3,196.1z"} fill="#2C2C2C" />;
    t12 = <path d={"M161,242.9c0.4,0.7,1.4,37.5,1.5,41.3l-4.8,0.1c-0.3,0-0.4-0.1-0.8-0.2c-0.2-0.8-0.3-9.8-0.3-10.9\n        c-0.1-9.9-0.4-20.1-0.3-30L161,242.9z"} fill="#F5F5F4" />;
    t13 = <path d={"M188,236.1c0.7,0.6,1.4,3.6,1.7,4.6l6.2,21c1.3,4.5,2.8,10.3,4.6,14.6l-4.4,1.5c-0.4,0.2-0.4,0.1-0.8,0\n        c-0.5-0.9-2.1-7-2.5-8.4c-3.1-10.6-6.4-21.4-8.9-32.1C185.1,236.9,186.6,236.5,188,236.1z"} fill="#F5F5F4" />;
    t14 = <path d={"M225.9,204.9c2,1.2,9.3,8.2,11.4,10.2c6.3,6,13,11.9,19.3,17.9c-1.1,1.5-2,2.5-3.2,3.9l-0.4,0.2\n        c-2.3-0.9-24.9-24.8-29.8-28.4C224.1,207.5,225,206.2,225.9,204.9z"} fill="#2C2C2C" />;
    t15 = <path d={"M219.6,213.2c0.6,0.1,1,0.3,1.4,0.8c5.6,6.3,11,12.7,16.4,19.2c3.2,3.9,6.5,7.6,9.6,11.6\n        c-1.1,1.3-2,2.2-3.3,3.4l-0.2,0.1c-2.1-0.6-22.6-28-26.9-31.8L219.6,213.2z"} fill="#515051" />;
    t16 = <path d={"M204.6,226.5l0.6,0.2c0.9,1.2,2.5,4.4,3.3,5.8c2,3.7,4,7.5,5.9,11.2c3.5,6.6,7,13.1,10.6,19.7\n        c-1.4,1.1-2.3,1.6-3.8,2.6c-0.4,0.2-0.3,0.1-0.7,0.2c-0.8-0.9-5.7-10.7-6.6-12.5L201,228.9C202,228.1,203.4,227.2,204.6,226.5z"} fill="#B6B5B6" />;
    t17 = <path d={"M196.7,231.7c0.7,0.6,1.2,2.3,1.6,3.3c1.3,3,2.5,6,3.8,9.1c3.4,8.5,7.6,18.1,10.6,26.6c-1.3,0.5-3.1,1.4-4.3,2\n        l-0.1,0c-1-0.5-1.7-3.2-2.1-4.3c-4.7-11.3-8.8-23.2-13.6-34.5C193.9,233,195.3,232.4,196.7,231.7z"} fill="#F5F5F4" />;
    t18 = <path d={"M178.4,239.6c0.7-0.1,0.3-0.1,1,0.1c2.6,13.6,5.4,27.2,8.4,40.7c-1,0.1-2.3,0.5-3.3,0.7\n        c-0.8,0.2-1.1,0.4-1.9,0.3c-0.9-2-2.3-10.9-2.9-13.7c-1.9-9.1-3.6-18.1-5.1-27.3L178.4,239.6z"} fill="#F5F5F4" />;
    t19 = <path d={"M212.1,220.2c0.1,0,0.1,0,0.2,0c1.6,0.4,21.8,30.6,24.3,34.5l-3,2.3c-0.5,0.4-0.8,0.5-1.3,0.8\n        c-0.2,0-0.3-0.1-0.5-0.2c-5.3-8.4-17.9-26.8-22.6-34.7C210.2,222.2,211.2,221.1,212.1,220.2z"} fill="#737373" />;
    t20 = <path d={"M167.7,241.8l2.5-0.2c1.2,11,2.5,22,3.9,33c0.2,1.3,1.2,7.8,0.6,8.5l-1.1,0.1l-4,0.3c-0.3-3.8-1-8.7-1.4-12.5\n        c-0.7-6.1-1.3-12.2-1.8-18.2c-0.2-2-1-8.7-0.8-10.5C166.1,241.9,166.9,241.9,167.7,241.8z"} fill="#F5F5F4" />;
    t21 = <path d={"M235.6,187.1c1.5,0.8,3.4,1.9,4.9,2.8c9.9,6,21.2,10.9,31,17c-0.9,1.4-1.6,2.9-2.4,4.4l-0.3,0.3\n        c-0.6,0.1-1.8-0.5-2.3-0.8c-7.4-4.7-15.1-8.9-22.7-13.3c-3.3-1.9-6.5-4-9.9-5.8C234.5,190.2,235,188.6,235.6,187.1z"} fill="#2C2C2C" />;
    t22 = <path d={"M238.9,178.1l21.2,8.4c5.4,2.1,10.6,4,16.1,6.2c-0.6,1.8-1.1,3.6-1.7,5.4c-1.1-0.6-4.1-1.6-5.5-2.2\n        c-4.8-2-9.6-4-14.5-6c-4.3-1.7-13.4-5.9-17.5-7L238.9,178.1z"} fill="#2C2C2C" />;
    t23 = <path d={"M241.3,169.1c6.3,0.9,15.6,3.9,22.1,5.3c5.4,1.2,11.1,2.4,16.3,4c-0.3,1.8-0.7,3.6-1.1,5.4\n        c-0.6,0.1-34.4-9.3-38.2-10.1C240.6,172.2,240.9,170.7,241.3,169.1z"} fill="#2C2C2C" />;
    t24 = <path d={"M242.7,159.7c3.7,0.1,8.7,1,12.5,1.3c8.7,0.8,18,2.2,26.6,2.8l-0.7,5.7c-4.1-0.9-8.5-1.3-12.7-1.9\n        c-8.7-1.2-17.5-2-26.2-3.5C242.5,162.8,242.6,161.1,242.7,159.7z"} fill="#2C2C2C" />;
    t25 = <path d={"M273.2,149.6l9-0.1c-0.1,1.8-0.2,3.6-0.3,5.4c-9.3-0.3-19.3-0.1-28.6-0.2c-3.4,0-6.7,0-10.1,0l0-4.2\n        c3.2-0.3,6.3-0.2,9.5-0.3C259.5,149.9,266.4,149.9,273.2,149.6z"} fill="#2C2C2C" />;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t13;
    $[8] = t14;
    $[9] = t15;
    $[10] = t16;
    $[11] = t17;
    $[12] = t18;
    $[13] = t19;
    $[14] = t2;
    $[15] = t20;
    $[16] = t21;
    $[17] = t22;
    $[18] = t23;
    $[19] = t24;
    $[20] = t25;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t10 = $[4];
    t11 = $[5];
    t12 = $[6];
    t13 = $[7];
    t14 = $[8];
    t15 = $[9];
    t16 = $[10];
    t17 = $[11];
    t18 = $[12];
    t19 = $[13];
    t2 = $[14];
    t20 = $[15];
    t21 = $[16];
    t22 = $[17];
    t23 = $[18];
    t24 = $[19];
    t25 = $[20];
    t3 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t26;
  if ($[28] !== className || $[29] !== rest || $[30] !== size) {
    t26 = <svg aria-label="Solfi" className={className} fill="none" height={size} viewBox="0 0 303 303" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}</svg>;
    $[28] = className;
    $[29] = rest;
    $[30] = size;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  return t26;
};